/**
 * Room References API
 */

import { apiClient } from "@/lib/api-client";

const API_BASE = "/api/v1";

export interface RoomReference {
	id: string;
	name: string;
	isDefault: boolean;
	createdBy: string | null;
}

export async function getRoomSuggestions(
	query: string = "",
	limit = 10,
): Promise<RoomReference[]> {
	try {
		const params = new URLSearchParams();
		if (query) params.set("q", query);
		params.set("limit", String(limit));
		const url = `${API_BASE}/rooms/suggestions?${params}`;
		const response = await apiClient.get(url);
		return response.data.data.rooms ?? [];
	} catch {
		return [];
	}
}

export async function createCustomRoom(
	name: string,
): Promise<{ success: boolean; room?: RoomReference; error?: string }> {
	try {
		const response = await apiClient.post(`${API_BASE}/rooms`, { name });
		return { success: true, room: response.data.data.room };
	} catch {
		return { success: false, error: "Failed to create room" };
	}
}
